import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { TenantSelectorService } from 'app/services/tenant-selector.service';
import { ConfigsLoaderService } from 'app/services/config-loader.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, 
              private authService: AuthService, 
              private config: ConfigsLoaderService,
              private selectorTenant: TenantSelectorService) {
  }
  // tslint:disable-next-line: no-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.authService.isLoggedIn())
      .pipe(
        switchMap(isLoggedIn => { // do the changes here
          const applicationId = '' + this.config.applicationId;
          const tenantId = !this.selectorTenant.currentSelectedTenant() ?
              null : this.selectorTenant.currentSelectedTenant()?.id.toString();
          if(req.url.includes('webexapis')){
              return next.handle(req);
            }
          if (isLoggedIn) {
            let clonedReq = req.clone({
              headers: req.headers.set('Authorization', this.authService.getAuthorizationHeaderValue())
                  .set('TenantId', tenantId)
                  .set('ApplicationId', applicationId)
            });
            //Set and send selectedLanguageId header just is not undefined
            if(MVLocalStorageService.getItem('selected_lang') && MVLocalStorageService.getItem('selected_lang') != 'undefined'){
              const selectedLanguageId = (JSON.parse(MVLocalStorageService.getItem('selected_lang'))).toString();
              clonedReq = clonedReq.clone({
                headers: clonedReq.headers.set('SelectedLanguageId', selectedLanguageId)
              });
            }
            return next.handle(clonedReq).pipe(
              tap(
                succ => { },
                err => {
                  if (err.status === 401) {
                    this.authService.logout();
                  }
                }
              )
            );
          } else {
            // const tenantId = this.selectorTenant.currentSelectedTenant() === undefined ?
            //   '1' : this.selectorTenant.currentSelectedTenant().id.toString();
            // debugger;
            // const tenantId = this.route.snapshot.paramMap.get('tenantId') ?? '-1';
            // const clonedReq = req.clone({
            //   headers: req.headers.set('TenantId', tenantId)
            // });
            // return next.handle(clonedReq);
            if (this.selectorTenant.currentSelectedTenant()) {
              let clonedReq = req.clone({
                headers: req.headers
                .set('TenantId', tenantId)
                .set('ApplicationId', applicationId)
              });
              if(MVLocalStorageService.getItem('selected_lang') && MVLocalStorageService.getItem('selected_lang') != 'undefined'){
                const selectedLanguageId = (JSON.parse(MVLocalStorageService.getItem('selected_lang'))).toString();
                clonedReq = clonedReq.clone({
                  headers: clonedReq.headers.set('SelectedLanguageId', selectedLanguageId)
                });
              }
              return next.handle(clonedReq);
            }
            let clonedReq = req.clone({
              headers: req.headers
              .set('ApplicationId', applicationId)
            });
            if(MVLocalStorageService.getItem('selected_lang') && MVLocalStorageService.getItem('selected_lang') != 'undefined'){
              const selectedLanguageId = (JSON.parse(MVLocalStorageService.getItem('selected_lang'))).toString();
              clonedReq = clonedReq.clone({
                headers: clonedReq.headers.set('SelectedLanguageId', selectedLanguageId)
              });
            }
            return next.handle(clonedReq);
          }
        })
      );
  }
}
